import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Constant from "../../../Constant";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

export default class ZoomLive extends Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.state = {
      name: this.props.name || "",
      description: this.props.desc || "",
      // content----------------
      meetingName: this.props.meetingName || "",
      meetingPassword: this.props.meetingPass || "",
      selectDate: new Date(),
      selectTime: new Date(),
      endMeetingDate: new Date(),
      meetingDate: new Date().toISOString(),
      meetingEndDate: new Date().toISOString(),
      traineeMeeting: "",
      studentMeeting: "",
      meetingID: null,
      topicCatagoryId: "zoom",
      //------------------------
      duration: this.props.duration,
      dateValues: {
        day: "",
        month: "",
        year: "",
        hours: "",
        minutes: "",
        secounds: "",
      },
      image: "",
      courseID: this.props.data,
    };
  }

  onInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleDay = (date) => {
    const { hours, minutes, secounds } = this.state.dateValues;

    this.setState({
      selectDate: date,
      meetingDate: date.toISOString(),
      dateValues: {
        hours,
        minutes,
        secounds,
        day: date.getDay().toString(),
        month: date.getMonth().toString(),
        year: date.getFullYear().toString(),
      },
    });
  };

  handleEndDay = (date) => {
    this.setState({
      meetingEndDate: date.toISOString(),
    });
  };

  handleTime = (date) => {
    const { day, month, year } = this.state.dateValues;

    this.setState({
      selectTime: date,
      dateValues: {
        day,
        month,
        year,
        hours: date.getHours().toString(),
        minutes: date.getMinutes().toString(),
        secounds: date.getSeconds().toString(),
      },
    });
  };

  uploadImg = (event) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new FormData();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("media", event.target.files[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/media/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data[0]);
        this.setState({
          image: result.data[0],
        });
      })
      .catch((error) => console.log("error", error));
  };

  onSubmit = () => {
    if (localStorage.getItem("livelms_role") !== "learner") {
      if (localStorage.getItem("lms_zconfig") !== "undefined" && localStorage.getItem("lms_zconfig") !== "null" && localStorage.getItem("lms_zconfig") !== "") {
        const {
          name,
          description,
          meetingName,
          meetingPassword,
          selectDate,
          selectTime,
          courseID,
          topicCatagoryId,
          image,
        } = this.state;

        const data = {
          name: name,
          description: description,
          image: image,
          content: {
            meetingName: meetingName,
            meetingPassword: meetingPassword,
            selectDate: selectDate.toISOString(),
            selectTime: selectTime,
            topicType: topicCatagoryId,
          },
          courseId: courseID,
          contentType: "zoom",
        };
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

        if (!this.props.name) {
          console.log("Insesrt Parameter");
          console.log("Edit Parameter", this.props.topicID);
          console.log("Edit Parameter", this.props.courseID);
          let urlencoded = new URLSearchParams();
          urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
          urlencoded.append("courseId", data.courseId);
          urlencoded.append("name", data.name);
          urlencoded.append("image", data.image);
          urlencoded.append("description", data.description);
          urlencoded.append("content", JSON.stringify(data.content));
          urlencoded.append("contentType", data.contentType);
          urlencoded.append("start", selectDate.toISOString());
          // urlencoded.append("end", data.contentType);
          urlencoded.append("isLive", true);
          urlencoded.append("duration", '45');

          let postRequestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
          };

          fetch(Constant.getAPI() + "/topic/add	", postRequestOptions)
            .then((response) => response.json())
            .then((result) => {
              console.log(result);
            })
            .catch((error) => console.log("error", error));
        } else {
          let urlencoded = new URLSearchParams();
          urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
          urlencoded.append("topicId", this.props.topicID);
          urlencoded.append("name", data.name);
          urlencoded.append("description", data.description);
          urlencoded.append("image", data.image);
          urlencoded.append("content", this.props.content);
          urlencoded.append("contentType", data.contentType);
          urlencoded.append("start", selectDate.toISOString());
          // urlencoded.append("end", data.contentType);
          urlencoded.append("isLive", true);
          urlencoded.append("duration", '45');
          let postRequestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
          };
          fetch(Constant.getAPI() + "/topic/update	", postRequestOptions)
            .then((response) => response.json())
            .then((result) => {
              console.log(result);
            })
            .catch((error) => console.log("error", error));
        }
      } else {
        Swal.fire("Configure your Zoom Account first and try with reLogin.!");
      }
    }
  };
  onConfigureZoom = () => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    let urlencoded = new URLSearchParams();
    urlencoded.append("siteName", localStorage.getItem("lms_site_name"));
    urlencoded.append("clientId", this.state.clientId);
    urlencoded.append("clientSecret", this.state.clientSecret);

    var zoomConfig = {
      clientId: this.state.clientId,
      clientSecret: this.state.clientSecret
    }
    let postRequestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };
    fetch(Constant.getAPI() + "/user/zoomConfig", postRequestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status === true) {
          window.open(result.data.url, '_blank');
          localStorage.setItem("lms_zconfig", JSON.stringify(zoomConfig));
          window.location.reload();
        }
      })
      .catch((error) => console.log("error", error));
  }
  render() {
    console.log(this.state.meetingEndDate);
    return (
      <div>
        <div>
          {
            localStorage.getItem("livelms_role") !== "learner"
              ?
              localStorage.getItem("lms_zconfig") === "undefined" || localStorage.getItem("lms_zconfig") === "null" || localStorage.getItem("lms_zconfig") === ""
                ?
                <div>
                  <h5>Zoom Configuration</h5>
                  <sub>**Create Zoom OAuth App from the Zoom Market place and Provide Secret Key and Secret Id details here.
                    {/* <Link to={"/lmsPageInfo"}>Click for More details related to the live class.</Link> */}
                  </sub>
                  <div class="form-group row">
                    <label class="col-form-label col-4 text-right" for="inputDefault">Client Id</label>
                    <input
                      type="text"
                      class="form-control col-8"
                      placeholder="Enter Client Id"
                      id="inputDefault"
                      name="clientId"
                      value={this.state.clientId}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div class="form-group row">
                    <label class="col-form-label col-4 text-right" for="inputDefault">Client Secret</label>
                    <input
                      type="text"
                      class="form-control col-8"
                      placeholder="Enter Client Secret"
                      id="inputDefault"
                      name="clientSecret"
                      value={this.state.clientSecret}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div class="row">
                    <div class="col-4 offset-8">
                      <button className="btn btn-primary" onClick={this.onConfigureZoom}>
                        Configure Zoom
                  </button>
                    </div>
                  </div>
                </div>
                :
                null
              :
              null
          }
          <hr />
          <div class="form-group">
            <div className="col-md-10">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Topic Name
                </label>
                {this.props.name ? (
                  <input
                    type="text"
                    class="form-control col-8"
                    placeholder="Enter Topic Name"
                    id="inputDefault"
                    name="name"
                    value={this.state.name}
                    readOnly
                  />
                ) : (
                    <input
                      type="text"
                      class="form-control col-8"
                      placeholder="Enter Topic Name"
                      id="inputDefault"
                      name="name"
                      value={this.state.name}
                      onChange={this.onInputChange}
                    />
                  )}
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Description
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Description"
                  id="inputDefault"
                  name="description"
                  value={this.state.description}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Meeting Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Meeting Name"
                  id="inputDefault"
                  name="meetingName"
                  value={this.state.meetingName}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Password
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Password"
                  id="inputDefault"
                  name="meetingPassword"
                  value={this.state.meetingPassword}
                  onChange={this.onInputChange}
                />
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Select Day
                </label>
                <div className="card border card-selector col-md-8 mini  d-flex flex-row day-picker">
                  <i class="far fa-calendar-alt" />
                  <DatePicker
                    selected={this.state.selectDate}
                    onChange={this.handleDay}
                    dateFormat="MMMM d, yyyy"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Select time
                </label>
                <div className="card border card-selector col-md-8 mini  d-flex flex-row day-picker">
                  <i class="far fa-clock" />
                  <DatePicker
                    selected={this.state.selectTime}
                    onChange={this.handleTime}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    dateFormat="h:mm aa"
                    timeCaption="Time"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Ending of Meeting Day
                </label>
                <div className="card border card-selector col-md-8 mini  d-flex flex-row day-picker">
                  <i class="far fa-calendar-alt" />
                  <DatePicker
                    selected={this.state.endMeetingDate}
                    onChange={this.handleEndDay}
                    dateFormat="MMMM d, yyyy"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Topic Catagory
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  id="inputDefault"
                  name="topicCatagoryId"
                  value={this.state.topicCatagoryId}
                  readOnly
                />
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Upload Topic Image
                </label>
                <input
                  type="file"
                  name="selectedFile"
                  onChange={this.uploadImg}
                  multiple
                />
                <div className="col-8 p-0"></div>
              </div>

              <div className="row">
                <div className="col-4"></div>
                <div className="col-8 p-0">
                  <button className="btn btn-primary" onClick={this.onSubmit}>
                    Save and View
                  </button>{" "}
                  or{" "}
                  <a href={`#/admin/course/topics/${this.state.courseID}`}>
                    Cancel
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
